import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import { createViewEdit, formatDateTime, getForm } from "../../utils/helpers";
import { URL_PAY_WEEK_CONFIGURATION } from "../../utils/urls";

// start_day / end_day use Python's weekday() numbering (Monday = 0 ... Sunday = 6)
export const WEEKDAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const weekdayOptions = WEEKDAYS.map((label, value) => ({
  label,
  value,
}));

export const weekdayName = (day: any) => WEEKDAYS[Number(day)] ?? day;

const districtName = (item: any) =>
  item?.district_name ?? item?.district?.name ?? item?.district;

const usePayWeekConfiguration = () => {
  const tableColumns = () => [
    {
      id: "district_name",
      header: "City",
      filter: {
        type: "text",
      },
    },
    {
      id: "start_day",
      header: "Start Day",
    },
    {
      id: "end_day",
      header: "End Day",
    },
    {
      id: "is_active",
      header: "Is Active",
    },
    {
      id: "created_at",
      header: "Created At",
      filter: {
        type: "date",
      },
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        district_name: districtName(item),
        start_day: weekdayName(item?.start_day),
        end_day: weekdayName(item?.end_day),
        is_active: <BooleanTags status={item?.is_active} />,
        created_at: formatDateTime(item?.created_at),
        actions: (
          <FormActions
            actions={[
              ...createViewEdit(URL_PAY_WEEK_CONFIGURATION, item?.id, true),
            ]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Pay Week Details",
          fields: {
            district: districtName(item),
            start_day: weekdayName(item?.start_day),
            end_day: weekdayName(item?.end_day),
            is_active: <BooleanTags status={item?.is_active} />,
          },
        },
        {
          title: "System Information",
          fields: {
            created_at: formatDateTime(item?.created_at),
            updated_at: formatDateTime(item?.updated_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(URL_PAY_WEEK_CONFIGURATION);

  return {
    tableColumns,
    tableData,
    formRoute,
    viewData,
  };
};

export default usePayWeekConfiguration;
